import { useEffect } from 'react';
import { getAnalyticsPlanSpeed } from '@belong/analytics';
import { usePromoCodeFromUrl } from '@belong/react-hooks';
import useAnalyticsEvents from '@belong/providers/analyticsEvents';
import useProducts from '@belong/providers/products';
import { ISectionPlanSummary } from './model';
import { PlanSummary } from './PlanSummary';
import { planStatusFilter } from './planStatusFilter';

const SectionPlanSummary = (props: ISectionPlanSummary) => {
  /*
   * When users from ISelect, etc get sent to our site, they land on pages with plans on them.
   * This is when we read their URL for a parameter to store for auto-applying in the promo
   * code screen later on in the signup process.
   */
  usePromoCodeFromUrl();

  const analyticsEvents = useAnalyticsEvents();

  const productsArr = props.plans.map(plan => plan.plan);
  const { setProducts } = useProducts();

  useEffect(() => {
    setProducts(productsArr);
  }, []);

  useEffect(() => {
    // TODO: Write a unit test for this
    // Products are typed as `any` so we can't rely on its shape. Plan cards
    // also use `any` type for product model so a breaking change to the model
    // will raise errors in E2E tests and inform us that analytics need to be
    // updated as well.
    analyticsEvents.send({
      category: 'ecommerce',
      action: 'product interaction',
      label: 'impression',
      products: props.plans
        .filter(plan => planStatusFilter(plan))
        .map(plan => ({
          productCode: plan.plan.productCode,
          productName: plan.plan.productName,
          productId: plan.plan.productId,
          description: plan.plan.description,
          currency: 'AUD',
          serviceType: 'new',
          // category: plan.plan.productType,
          planSpeed: getAnalyticsPlanSpeed(plan.plan),
          quantity: 1,
          price: plan.plan.price.value
        }))
    });
  }, [analyticsEvents, props.plans]);

  return <PlanSummary {...props} isPreSq />;
};

export default SectionPlanSummary;
